<template>
  <div :id="`allowlist_${item.name}`" class="c-allowlist__item cursor-pointer">
    <el-row :type="'flex'">
      <el-col :span="24">
        <el-button type="danger" plain>{{ item.type }} Allow Rule</el-button>
      </el-col>
    </el-row>
    <el-row :type="'flex'">
      <el-col :span="24">
        <p v-for="(condition, index) in item.conditions" :key="index">
          <el-button type="info" v-if="index !== 0">AND</el-button>
          {{ condition.level }} event.{{ condition.attribute }} {{ condition.operator }} {{ condition.values }}
        </p>
      </el-col>
    </el-row>
    <el-row :type="'flex'">
      <el-col :span="24">
        <div class="float-right">
          Apply To -- <span v-if="item.allRules"> All Rules</span>
          <span v-else>
            <el-button v-for="(rule, index) in item.rules" :key="index">{{ rule }}</el-button>
          </span>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
export default {
  name: 'AllowlistTranslationItem',
  props: {
    item: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {}
  },
  methods: {},
  created () {},
  beforeDestroy: function () {},
  components: {}
}
</script>

<style scoped>
@import 'assets/styles/_variables.css';
@import 'assets/styles/colors.css';
@import 'assets/styles/text.css';
@import 'assets/styles/icon.css';

.c-trail_item {
  padding: 8px 8px;

  .cell {
    box-sizing: border-box;
    white-space: normal;
    word-break: break-all;
  }

  .item-name {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    h6 {
      line-height: 20px;
    }

    .el-divider--vertical {
      height: 1.25em;
    }

    .material-icons {
      font-size: 1.25em;
      color: var(--aluminum-600);
    }

    time {
      color: var(--gray-400);
      float: right;
    }

    .timestamp {
      vertical-align: text-top;
    }
  }

  .item-score {
    margin-left: 12%;

    span {
      display: block;
    }
  }

  .close-sidebar {
    font-size: 1.25em;
    line-height: 1em;
  }

  .item-summary {
    .summary-block {
      height: 16px;
      width: 16px;
      border-radius: 50%;
      margin: auto;
      margin-bottom: 4px;
    }

    span {
      text-align: center;

      &.icon-hosts {
        margin: 0px;
      }
    }
  }

  .material-icons {
    font-size: 2em;
    margin-left: 10px;
  }

  .item-expand.disabled {
    color: var(--tuna-400);
  }

  .circle {
    width: 20px;
    height: 20px;
    display: table-cell;
    border-radius: 50%;
    font-size: 10px;
    color: #fff;
    line-height: 20px;
    text-align: center;
    background: var(--primary-blue-400);
  }

  .avatar-wrapper {
    align-items: stretch;
  }

  .avatar-circle {
    color: white;
    letter-spacing: -1px;
    font-size: 13px;
    height: 32px;
    width: 32px;
    padding: 0px;
    margin: 0px;
    position: relative;
  }

  .icon-unassigned {
    width: 32px;
    height: 32px;
    margin: 0px;
    mask-size: cover;
  }

  .link {
    padding: 1px;
    margin-top: 5px;

    .icon {
      mask-size: cover;
      color: var(--aluminum-600);
    }
  }

  .material-icons.item-expand,
  .icon-trail {
    color: var(--aluminum-600);
  }
}

.c-trail_item.active {
  box-shadow: 2px 2px 12px 2px rgba(0, 0, 0, 0.1);
}

.c-trail_item:hover {
  background-color: var(--aluminum-100);
}

.active-row {
  box-shadow: 2px 2px 12px 2px rgba(0, 0, 0, 0.1);
}
</style>



// WEBPACK FOOTER //
// src/components/card/AllowlistTranslationItem.vue